export enum OrderType {

    EntryLimit = 1,
    EntryStop = 2,
    TakeProfit = 3,
    StopLoss = 4,
    Market = 5
}
